import axios from "axios";

import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";
import { REST_API_WORKSUITE_V3 } from "../../../constants";
import {
  handleRequestErrors,
  momentFormat,
} from "../../apps/ecommerce/utils/utils";
import moment from "moment";

// ** token
const user = JSON.parse(localStorage?.getItem("userData"));
const token = `Bearer ${user?.data?.token}`;
const token_company = (localStorage?.getItem("token_company"));

export const useGetRoleUser = () => {
  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}accounts/role-users`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data.data;
    } catch (error) {
      return toast.error(error.response.data.error.message);
    }
  };
  const query = useQuery(["role-users"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

// ** get Total Project
export const useGetTotalProject = () => {
  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/total-project`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["private-totalProjects"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

// ** get Total task
export const useGetTotalTask = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/total-task`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["private-totalTasks"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

// ** get Total employees
export const useGetTotalEmployees = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/total-employee`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["private-totalEmployees"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

// ** get Total clients
export const useGetTotalClients = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/total-client`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["private-totalClients"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

// ** get Total Projects Activity
export const useGetTotalProjectsActivity = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}dashboard/projects/activity`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["totalProjectsActivity"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

// ** get Total user Activity
export const useGetTotalUserActivity = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}dashboard/users/activity`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["totalUsersActivity"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

// ** get Total task due date
export const useGetTotalTaskDueDate = (pages) => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/task-incomplete?page=${pages}`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["task-incomplete", pages], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};
// ** get Total task due date
export const useGetTotalTaskDueDateByNotification = (pages) => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/task-incomplete?limit=50&page=${pages}`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["task-incomplete", pages], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

// ** get Total task due date
export const useGetTotalMilestoneDueDate = (pages) => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/milestone-incomplete?page=${pages}`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["milestone-incomplete", pages], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};
// ** get Total task due date
export const useGetTotalMilestoneDueDateByNotification = (pages) => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/milestone-incomplete?limit=50&page=${pages}`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["milestone-incomplete", pages], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};
// ** get Total Tickets
export const useGetTotalTicket = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/total-ticket`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["private-totalTickets"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

export const useGetTotalInvoices = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}private-dashboards/total-invoice`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["private-totalInvoices"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

export const useGetTotalLead = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}publish-dashboards/total-lead`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["publish-totalLead"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

export const useGetTotalProposal = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}publish-dashboards/total-proposal`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["publish-totalproposal"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

export const useGetTotalMilestone = () => {

  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}publish-dashboards/total-milestone`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["publish-totalmilestones"], request, {
    refetchOnWindowFocus: false,
  });
  return query;
};

// api report proposal
export const useGetCountProposals = ({ state }) => {
  const { start, end } = state;
  const start_date = moment(state.start).format(momentFormat(start));
  const end_date = moment(state.end).format(momentFormat(end));
  const request = async () => {
    const decodeQueryParam = (p) => {
      return decodeURIComponent(p.replace(/\+/g, " "));
    };
      var field = decodeQueryParam(
        `total-author?date_from=${start_date}&date_to=${end_date}`
      );
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}proposals/${field}`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(
    ["countPorposalsByAuthor", { start_date, end_date }],
    request,
    {
      refetchOnWindowFocus: false,
    }
  );
  return query;
};

export const useGetCountByTicket = ({ state }) => {
  const moment_format = momentFormat();
  const start_date = moment(state.start).format(moment_format);
  const end_date = moment(state.end).format(moment_format);
  const request = async () => {
    const decodeQueryParam = (p) => {
      return decodeURIComponent(p.replace(/\+/g, " "));
    };
      var field = decodeQueryParam(
        `total-agent?date_from=${start_date}&date_to=${end_date}`
      );
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}tickets/${field}`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(
    ["countTicketByAgent", { start_date, end_date }],
    request,
    {
      refetchOnWindowFocus: false,
    }
  );
  return query;
};

export const useGetTicketActivity = (pages) => {
  const request = async () => {
    const config = {
      method: "get",
      url: `${REST_API_WORKSUITE_V3}ticket-histories?page=${pages}&type=reply`,
      headers: {
        Authorization: token,
        "X-WorkSuite-Company-Token": token_company,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      return handleRequestErrors(error);
    }
  };
  const query = useQuery(["ticket-activity", pages], request, {
    refetchOnWindowFocus: false,
  });
  return query;
}
